import SignInShowtimeMigratedComponent from 'aa/vue/components/SignInShowtimeMigrated';
import Step from 'models/steps/Step';
import { PAGE_TYPES } from 'aa/vue/constants/aaTrackingConstants';

export default class SignInShowtimeMigrated extends Step {
    path = '/account/signin/showtime/';
    name = 'SIGNIN_SHOWTIME_MIGRATED';
    component = SignInShowtimeMigratedComponent;
    requireAuth = false;
    requireNonAuth = true;
    hideSignInLink = true;

    /**
     * Overriding using same page tag as primary signin page to inherit page attributes
     * @returns {string}
     */
    getPageAttributesPageTag() {
        return 'page_signin';
    }

    getRoute() {
        const route = super.getRoute();
        const meta = {
            hideHeader: true,
        };

        if (route.meta && typeof route.meta === 'object') {
            Object.assign(route.meta, meta);
        } else {
            route.meta = meta;
        }

        return route;
    }

    getTrackingArgs(to) {
        const args = super.getTrackingArgs(to);

        args.pageType = PAGE_TYPES.SIGNIN_SHO_MIGRATED;

        return args;
    }
}
